import React from 'react';

import {faXmark} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Button from 'components/Button/Button';
import Checkbox from 'components/Checkbox/Checkbox';
import Text from 'components/Text/Text';
import {useGlobalState} from 'hooks/useGlobalState';
import useOnClickOutside from 'hooks/useOnClickOutside';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {setBreweryFiltersAC, setCheckedBreweryTypesAC} from 'store/breweries/breweriesSlice';
import {getBreweriesACS} from 'store/breweries/requestAC';
import {setShowFilterAC} from 'store/filter/filterSlice';

interface IProps {
  show: boolean;
}

export const BreweryTypeFilter = ({show}: IProps) => {
  const options = ['Nano Brewery', 'Micro Brewery', 'Brew Pub', 'Regional Brewery', 'Macro Brewery'];

  const dispatch = useSetGlobalState();

  const {checkedBreweryTypes, filters} = useGlobalState((state) => state.breweries);

  const {containerRef} = useOnClickOutside<HTMLDivElement>(() => {
    dispatch(setShowFilterAC(false));
  });

  const handleClear = () => {
    dispatch(setCheckedBreweryTypesAC([]));
    dispatch(setBreweryFiltersAC({...filters, breweryTypeQuery: ''}));
    dispatch(getBreweriesACS({...filters, breweryTypeQuery: ''}));
  };

  const handleApplyFilter = (checkedBrewery: string[]) => {
    const breweryTypeQuery = checkedBrewery
      .map((breweryType) => {
        let query = '&filter_search[brewery_kind][]=';
        switch (breweryType) {
          case 'Brew Pub':
            query += 0;
            break;
          case 'Nano Brewery':
            query += 1;
            break;
          case 'Regional Brewery':
            query += 2;
            break;
          case 'Micro Brewery':
            query += 3;
            break;
          case 'Macro Brewery':
            query += 4;
            break;
        }
        return query;
      })
      .join('');

    dispatch(getBreweriesACS({...filters, breweryTypeQuery}));
    dispatch(setBreweryFiltersAC({...filters, breweryTypeQuery}));
  };

  const handleCheck = (breweryType: string) => {
    let payload = [...checkedBreweryTypes, breweryType];
    if (checkedBreweryTypes.includes(breweryType)) payload = checkedBreweryTypes.filter((type) => type !== breweryType);
    dispatch(setCheckedBreweryTypesAC(payload));

    handleApplyFilter(payload);
  };

  return (
    <div ref={containerRef}>
      {show && (
        <div className="filter" data-testid="style-filter">
          <Button variant="default" onClick={handleClear} title="Clear all beer styles from filter">
            Clear All
            <FontAwesomeIcon icon={faXmark} />
          </Button>
          <div className="filter__items">
            {options.map((beerType) => {
              return (
                <div
                  key={beerType}
                  className={`filter__item ${checkedBreweryTypes.includes(beerType) ? 'filter__item--checked' : ''}`}
                >
                  <Checkbox
                    type="secondary"
                    checked={checkedBreweryTypes.includes(beerType)}
                    onChange={() => handleCheck(beerType)}
                  />
                  <Text tag="p">{beerType}</Text>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
